import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#D8FFFF" d="M6.57 92.3a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m108.37 42.81 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.59.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94c-.59.59-.59 1.54 0 2.12.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM96.22 14.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M23.2 64.13h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H9.06c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M28.07 105.48c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M81.93 37.51 59.81 19.88a2.9 2.9 0 0 0-3.63 0L34.06 37.51v39.71c0 2.4 1.95 4.35 4.35 4.35h39.17c2.4 0 4.35-1.95 4.35-4.35zM81.93 35.3V19.69c0-.69-.56-1.26-1.26-1.26h-6.19c-.69 0-1.26.56-1.26 1.26v9.95"
    />
    <path
      fill="#fff"
      d="M51.04 51.77h14.11c1.31 0 2.37 1.06 2.37 2.37v27.43H48.68V54.14c0-1.31 1.06-2.37 2.37-2.37z"
    />
    <path
      fill="#0597A3"
      d="M25.36 45.4c-.92 0-1.83-.42-2.42-1.23-.98-1.34-.69-3.21.65-4.19l30.06-22.05a7.31 7.31 0 0 1 8.69 0l30.07 22.05c1.34.98 1.62 2.86.64 4.19a3.003 3.003 0 0 1-4.19.65L58.8 22.77a1.35 1.35 0 0 0-1.6 0L27.14 44.82c-.53.39-1.16.58-1.77.58zM86.13 85H29c-1.66 0-3-1.34-3-3s1.34-3 3-3h57.13c1.66 0 3 1.34 3 3s-1.34 3-3 3"
    />
    <path
      fill="#00D8D8"
      d="M67.89 95.05c-1.24 0-2.25-1.01-2.25-2.25v-6.58c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v6.58c0 1.24-1.01 2.25-2.25 2.25M92.32 95.05c-1.24 0-2.25-1.01-2.25-2.25v-6.58c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v6.58c0 1.24-1.01 2.25-2.25 2.25"
    />
    <path
      fill="#D8FFFF"
      d="M94.05 67.73H66.16a2.17 2.17 0 0 0-2.17 2.17v14.15a2.17 2.17 0 0 0 2.17 2.17h27.89a2.17 2.17 0 0 0 2.17-2.17V69.9a2.17 2.17 0 0 0-2.17-2.17"
    />
    <path
      fill="#001A43"
      d="M87.08 79.22H73.11c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h13.97c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25"
    />
  </svg>
);
const SvgEnrichedIconSoldBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSoldBrand);
export default Memo;
